import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useProjectOptions } from '@/hooks/useProjectOptions';
import type { EntityOptionResponse } from '@/types/entityOption';
import { useSelectLabels } from '@/hooks/useSelectLabels';

export interface ProjectSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onProjectChange?: (project: EntityOptionResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  showDetails?: boolean;
}

export function ProjectSelect({
  label = 'Project',
  value = '',
  onChange,
  onProjectChange,
  placeholder,
  disabled,
  className,
  required,
  error,
  showDetails: _showDetails = true,
}: ProjectSelectProps) {
  const selectLabels = useSelectLabels();
  const { options, loading, getProject } = useProjectOptions();

  const handleChange = (next: string) => {
    onChange?.(next);
    onProjectChange?.(next ? getProject(next) ?? null : null);
  };

  return (
    <div className={className}>
      <SearchableSelect
        label={label}
        required={required}
        error={error}
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={placeholder ?? selectLabels.selectProject}
        disabled={disabled}
        loading={loading}
        searchPlaceholder={selectLabels.searchProjects}
        emptyMessage={selectLabels.noProjects}
      />
    </div>
  );
}
